const WEB_URL  = "http://www.venkateswarajewellery.com";

const BASE_URL = "https://app3.zinger.co.in";

export { BASE_URL, WEB_URL };